import { useAppSelector } from 'app/store';
import { BottomFromTechnicianCoordinatorRoles } from '../../constants';

export function IsBottomFromTechnicianCoordinator({ children }) {
  const groups = useAppSelector((state) => state.auth.groups);
  if (groups?.some((role) => BottomFromTechnicianCoordinatorRoles.includes(role))) {
    return children;
  }
  return null;
}
